import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_Smtp,
  PUT_Smtp,
  POST_SmtpTest,
  GET_NotificationPref,
  PUT_NotificationPref,
} from "../services/Setting";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_SmtpEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_Smtp, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_Smtp", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_SmtpEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    const res = yield call(PUT_Smtp, token, formData);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_Smtp", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_SmtpTestEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload || {});
    formData.append("data", data);
    const res = yield call(POST_SmtpTest, token, formData);
    // 成功訊息裡有實際收件人，直接把 res_msg 交給呼叫端顯示
    if (callback) callback(res.res_msg);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_NotificationPrefEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_NotificationPref, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_NotificationPref", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_NotificationPrefEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    const res = yield call(PUT_NotificationPref, token, formData);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_NotificationPref", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* SettingSaga() {
  yield takeLatest("GET_Smtp", GET_SmtpEffect);
  yield takeLatest("PUT_Smtp", PUT_SmtpEffect);
  yield takeLatest("POST_SmtpTest", POST_SmtpTestEffect);
  yield takeLatest("GET_NotificationPref", GET_NotificationPrefEffect);
  yield takeLatest("PUT_NotificationPref", PUT_NotificationPrefEffect);
}
